import { render, staticRenderFns } from "./VaultDeatil.vue?vue&type=template&id=04588522&scoped=true&"
import script from "./VaultDeatil.vue?vue&type=script&lang=js&"
export * from "./VaultDeatil.vue?vue&type=script&lang=js&"
import style0 from "./VaultDeatil.vue?vue&type=style&index=0&id=04588522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04588522",
  null
  
)

export default component.exports